"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const errors_1 = require("@ledgerhq/errors");
const sdk_1 = require("@hashgraph/sdk");
const utils_1 = require("./utils");
function getTransactionStatus(account, transaction) {
    return __awaiter(this, void 0, void 0, function* () {
        const errors = {};
        if (!transaction.recipient || transaction.recipient.length === 0) {
            errors.recipient = new errors_1.RecipientRequired("");
        }
        else {
            if (account.freshAddress === transaction.recipient) {
                errors.recipient = new errors_1.InvalidAddressBecauseDestinationIsAlsoSource("");
            }
            try {
                sdk_1.AccountId.fromString(transaction.recipient);
            }
            catch (err) {
                errors.recipient = new errors_1.InvalidAddress("", {
                    currencyName: account.currency.name,
                });
            }
        }
        const { amount, totalSpent } = yield (0, utils_1.calculateAmount)({
            transaction,
            account,
        });
        if (transaction.amount.eq(0) && !transaction.useAllAmount) {
            errors.amount = new errors_1.AmountRequired();
        }
        else if (account.balance.isLessThan(totalSpent)) {
            errors.amount = new errors_1.NotEnoughBalance("");
        }
        const estimatedFees = yield (0, utils_1.getEstimatedFees)();
        return {
            amount,
            errors,
            estimatedFees,
            totalSpent,
            warnings: {},
        };
    });
}
exports.default = getTransactionStatus;
//# sourceMappingURL=js-getTransactionStatus.js.map